import { Box, Typography } from "@mui/material";

import IdentitySection from "./components/IdentitySection";
import ContactSection from "./components/ContactSection";
import AddressSection from "./components/AddressSection";
import SubmitButton from "./components/SubmitButton";
import ProfileFormSkeleton from "./components/ProfileFormSkeleton";
import { profileAccent } from "./components/profileFormStyles";

import { useAccountSetup } from "./hooks/useAccountSetup";

const ProfileSetupPage = () => {
  const {
    formData,
    errors,
    loading,
    initialLoading,
    imageLoading,
    profileImage,
    isPJ,
    handleChange,
    handleSubmit,
    handleCEPBlur,
    handleProfileImageChange,
  } = useAccountSetup();

  return (
    <Box
      sx={{
        backgroundColor: { xs: "#ffffff", md: "transparent" },
        px: { xs: 0, sm: 3, lg: 5 },
        py: { xs: 0, md: 5 },
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        noValidate
        sx={{
          backgroundColor: "#ffffff",
          border: { xs: 0, md: "1px solid #dce4ee" },
          borderRadius: { xs: 0, md: "12px" },
          boxShadow: { xs: "none", md: "0 12px 30px rgba(15, 23, 42, 0.04)" },
          boxSizing: "border-box",
          maxWidth: 1000,
          mx: "auto",
          overflow: "hidden",
          px: { xs: 2, sm: 4, md: 5 },
          py: { xs: 2, md: 4 },
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography
            sx={{
              alignItems: "center",
              color: "#111827",
              display: "flex",
              fontSize: 18,
              fontWeight: 700,
              gap: 1,
              lineHeight: 1.3,
              "&::before": {
                backgroundColor: profileAccent,
                borderRadius: "999px",
                content: '""',
                display: "inline-block",
                height: 18,
                width: 3,
              },
            }}
          >
            Dados da conta
          </Typography>
        </Box>

        {initialLoading ? (
          <ProfileFormSkeleton />
        ) : (
          <>
            <IdentitySection
              formData={formData}
              errors={errors}
              isPJ={isPJ}
              handleChange={handleChange}
              imageLoading={imageLoading}
              profileImage={profileImage}
              handleProfileImageChange={handleProfileImageChange}
            />

            <ContactSection
              formData={formData}
              errors={errors}
              handleChange={handleChange}
            />

            <AddressSection
              formData={formData}
              errors={errors}
              handleChange={handleChange}
              handleCEPBlur={handleCEPBlur}
            />

            <SubmitButton loading={loading} />
          </>
        )}
      </Box>
    </Box>
  );
};

export default ProfileSetupPage;
